import { GroupTag } from "@/types/v2";

export function useChallengeTaskOperations() {
  const removeLeadingHash = (color: string | undefined): string => {
    return color ? color.replace("#", "") : "";
  };

  const getTagStyles = (tag: GroupTag) => ({
    border: "1px solid rgba(0, 0, 0, .1)",
    color: `#${removeLeadingHash(tag.textColor)}`,
    backgroundColor: `#${removeLeadingHash(tag.backgroundColor)}`,
  });


  return {
    removeLeadingHash,
    getTagStyles,
  };
}
